export default "__VITE_ASSET__CNtz$I6a__"